import { store } from 'store'
import { messagesSelectors } from 'store/messages'
import { settingsSelectors } from 'store/settings'
import { analytics } from './analytics'
import { ANALYTICS_EVENTS, MessageSource } from './events'

type TrackBotMessageSentParams = {
  source: MessageSource
  attachmentCount?: number
}

/**
 * Call right after the optimistic user message is in the store, so message_count includes it.
 * The operator path tracks its own event: there the message only lands after the POST.
 * agentic_enabled is the tenant flag, not whether this question actually went agentic: that also
 * depends on the required agent inputs, and is only known inside askBotAnswer.
 */
export const trackBotMessageSent = ({ source, attachmentCount = 0 }: TrackBotMessageSentParams) => {
  const state = store.getState()
  analytics.track(ANALYTICS_EVENTS.MESSAGE_SENT, {
    mode: 'bot',
    source,
    attachment_count: attachmentCount,
    message_count: messagesSelectors.userMessageCount(state),
    agentic_enabled: settingsSelectors.agenticEnabled(state),
  })
}
